<template>
  <div class="filter-column">
    <filter-age @ageChange="$emit('ageChange', data)" />
  </div>
</template>

<script>
export default {
  props: ["filters"],
  data() {
    return {
      rating: 4,
      range: [0, 50],
      isOpen: false,
    };
  },
  watch: {},
  methods: {},
  mounted() {
    // this.category = JSON.parse(this.category);
    console.log("mounted filters");
  },
  created() {
    // console.log(JSON.parse(this.category));
  },
  computed: {},
};
</script>

<style>
</style>
